import { Reveal, ParallaxImage } from "./Motion";

const MODEL_IMG =
    "https://images.pexels.com/photos/33714925/pexels-photo-33714925.jpeg?auto=compress&cs=tinysrgb&w=1200";

const BELIEFS = ["Independent", "Senior-only teams", "Channel-agnostic", "Accountable to outcomes"];

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="border-t border-line px-5 md:px-10 py-24 md:py-32">
            <div className="grid gap-14 lg:grid-cols-12 lg:gap-16">
                <div className="lg:col-span-4">
                    <div className="lg:sticky lg:top-28 flex flex-col gap-8">
                        <Reveal>
                            <p className="eyebrow mb-6 flex items-center gap-3">
                                <span className="h-px w-10 bg-vermilion" /> The consultancy
                            </p>
                            <h2 className="display-xl font-display font-light text-paper">
                                Small team.
                                <br />
                                Loud results<span className="text-vermilion">.</span>
                            </h2>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <ul className="flex flex-col gap-3" data-testid="about-beliefs">
                                {BELIEFS.map((b) => (
                                    <li key={b} className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-smoke">
                                        <span className="h-1.5 w-1.5 bg-vermilion" /> {b}
                                    </li>
                                ))}
                            </ul>
                        </Reveal>
                    </div>
                </div>

                <div className="lg:col-span-8 flex flex-col gap-12">
                    <Reveal>
                        <div className="max-w-2xl space-y-6 text-base md:text-lg font-light leading-relaxed text-paper/90">
                            <p>
                                HVP Consultants is an independent marketing and business
                                consultancy built around a simple belief: brands don't win by
                                spreading budgets across channels — they win by making every
                                channel amplify the same idea.
                            </p>
                            <p className="text-smoke">
                                We sit at the junction of media, digital, social, PR and data. One team
                                plans the buy, the feed and the headline together, so a campaign
                                lands everywhere at once instead of trickling out one channel at a
                                time. Lean by design, senior by default, and accountable to numbers
                                — not deliverables.
                            </p>
                        </div>
                    </Reveal>

                    <div className="grid gap-8 md:grid-cols-5">
                        <Reveal delay={0.08} className="md:col-span-3">
                            <ParallaxImage
                                src={MODEL_IMG}
                                alt="Editorial fashion shoot in red studio light"
                                className="aspect-[3/4] w-full border border-line"
                            />
                        </Reveal>
                        <Reveal delay={0.16} className="md:col-span-2 flex flex-col justify-end">
                            <div className="border border-line p-6 md:p-8 bg-card/50">
                                <p className="font-display text-2xl md:text-3xl font-light italic leading-snug text-paper">
                                    "Transparent by design. Performance by default."
                                </p>
                                <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-vermilion">
                                    — The HVP principle
                                </p>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
